import { render, staticRenderFns } from "./DataSegments.vue?vue&type=template&id=29478f26&"
import script from "./DataSegments.vue?vue&type=script&lang=js&"
export * from "./DataSegments.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports